import { jsx as _jsx } from "react/jsx-runtime";
import { Box, useStyleConfig } from '@companydotcom/potion';
export const PageDivider = props => {
    const styles = useStyleConfig('PageDivider');
    return _jsx(Box, Object.assign({ className: "pageDivider", as: "hr", sx: styles }, props), void 0);
};
